<template>
  <div class="mx-4">
    <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">Structuur van de export</p>
    <p class="mb-4 font-opensans">
      De export wordt aangeboden als een XLSX-bestand. Dit bestand is in de meeste statistische pakketten en spreadsheets in te lezen.
      De eerste rij van de export bevat de kolomnamen.
    </p>

    <p class="mb-4 font-opensans">
      In de export is per accommodatie per sport een rij aangemaakt. Hierdoor kunnen sport-specifieke eigenschappen worden meegegeven,
      zoals het aantal indoor tennisbanen of het aantal voetbalvelden met de ondergrond "natuurgras".
    </p>

    <p class="mb-4 font-opensans">
      De huidige export bevat de volgende kolommen:
      <table class="table table-striped">
          <thead>
              <tr>
                  <th scope="col">Kolomnaam</th>
                  <th scope="col">Omschrijving</th>
              </tr>
          </thead>
          <tbody>
            <tr><td>accommodatie_id</td><td>Het unieke ID van de accommodatie. Hierop kan eventueel ontdubbeld worden.</td></tr>
            <tr><td>accommodatie naam</td><td>De naam van de accommoatie.</td></tr>
            <tr><td>bouwjaar</td><td>Het (vaak eerst bekende) bouwjaar van de accommodatie.</td></tr>
            <tr><td>X</td><td>X-coordinaat van de accommodatie in het Amersfoort New stelsel.</td></tr>
            <tr><td>Y</td><td>Y-coordinaat van de accommodatie in het Amersfoort New stelsel.</td></tr>
            <tr><td>adres</td><td>Straatnaam + huisnummer van de accommodatie</td></tr>
            <tr><td>postcode</td><td>Postcode van de accommodatie</td></tr>
            <tr><td>plaatsnaam</td><td>Plaatsnaam</td></tr>
            <tr><td>gemeente</td><td>Gemeente</td></tr>
            <tr><td>provincie</td><td>Provincie</td></tr>
            <tr><td>aantal voorzieningen</td><td>Het aantal voorzieningen (sportspecifiek)</td></tr>
            <tr><td>aantal indoor voorzieningen</td><td>Het aantal indoor voorzieningen (sportspecifiek)</td></tr>
            <tr><td>aantal outdoor voorzieningen</td><td>Het aantal outdoor voorzieningen (sportspecifiek)</td></tr>
            <tr><td>aantal outdoor kunstgrasvelden</td><td>Het aantal outdoor kunstgrasvelden (sportspecifiek)</td></tr>
            <tr><td>aantal outdoor natuurgrasvelden</td><td>Het aantal outdoor natuurgrasvelden (sportspecifiek)</td></tr>
            <tr><td>aantal outdoor semi-watervelden</td><td>Het aantal outdoor semi-watervelden (sportspecifiek)</td></tr>
            <tr><td>aantal outdoor watervelden</td><td>Het aantal outdoor watervelden (sportspecifiek)</td></tr>
            <tr><td>aantal sporthallen</td><td>Het aantal sporthallen (sportspecifiek)</td></tr>
            <tr><td>aantal sportzalen</td><td>Het aantal sportzalen (sportspecifiek)</td></tr>
            <tr><td>aantal gymzalen</td><td>Het aantal gymzalen (sportspecifiek)</td></tr>
            <tr><td>sport</td><td>Sport</td></tr>
        </tbody>
      </table>


    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
